import { Indicator, Root } from '@radix-ui/react-progress';
import * as React from 'react';
import classNames from '@/lib/classNames';

const ProgressBar = React.forwardRef<React.ElementRef<typeof Root>, React.ComponentPropsWithoutRef<typeof Root>>(({ className, value, ...props }, ref) => (
    <Root ref={ref} className={classNames('relative h-2 w-full overflow-hidden rounded-full border-primary border-[0.1rem] transition-all', className)} {...props}>
        <Indicator className="h-full w-full flex-1 bg-primary transition-all" style={{ transform: `translateX(-${100 - (value || 0)}%)` }} />
    </Root>
));
ProgressBar.displayName = Root.displayName;

export { ProgressBar };
